"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Location = require("./Location");

var _Location2 = _interopRequireDefault(_Location);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents a page of Locations
 * @param {Object} page response object
 */
class LocationsPage {
  constructor(fields) {
    if (!fields) {
      return;
    }

    if (fields.items) {
      this.items = fields.items.map(item => new _Location2.default(item));
    }

    if (fields.count) {
      this.count = fields.count;
    }

    if (fields.lastKey) {
      this.lastKey = fields.lastKey;
    }
  }
}
exports.default = LocationsPage;